module.exports = __webpack_public_path__ + "static/media/cloudy.527cfb73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather/cloudy.png
// module id = 6652
// module chunks = 0